module.exports = {
          srcSet: __webpack_public_path__ + "5ec4fd44.jpg"+" 700w"+","+__webpack_public_path__ + "e79b68ee.jpg"+" 1400w"+","+__webpack_public_path__ + "ce1174dc.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "5ec4fd44.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "e79b68ee.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "ce1174dc.jpg",width: 2048,height: 1536}],
          src: __webpack_public_path__ + "5ec4fd44.jpg",
          toString:function(){return __webpack_public_path__ + "5ec4fd44.jpg"},
          
          width: 700,
          height: 525
        }